import * as React from 'react'
import { parseTransactionName } from '../../../ui/transactionName'
import { Col, Row } from '../../../ui/grid'
import Shorten from '../../../helper/shorten'

interface OwnProps {
    transaction: string
}

class TracepointFormHeader extends React.Component<OwnProps> {
    public render() {
        const { transaction } = this.props
        const { name: transactionName } = parseTransactionName(transaction)

        return (
            <Row>
                <Col width={3}>
                    <label className="control-label tw-ml-8">Transaction</label>
                </Col>
                <Col width={9}>
                    <Shorten string={transactionName} />
                    {this.transactionIsScript(transaction) && (
                        <div className="alert alert-warning tw-ml-0 tw-mt-8">
                            <h4>
                                <i className="fa fa-warning" /> Creating a tracepoint on a PHP script
                            </h4>
                            If you create a tracepoint for this PHP script <strong>{transaction}</strong>, it will enable the callgraph
                            profiler whenever this script is executed, even in cases where it later changes the transaction name.
                        </div>
                    )}
                </Col>
            </Row>
        )
    }

    private transactionIsScript = (transaction: string): boolean => /.*\/.*\.php$/i.test(transaction)
}
export default TracepointFormHeader
